import { apiClient } from "../../lib/apiClient";

export interface AdminInvite {
  id: string;
  email: string;
  role: "super_admin" | "project_user";
  game_id: string | null;
  expires_at: string;
  accepted_at: string | null;
  revoked_at: string | null;
  status: "pending" | "accepted" | "expired" | "revoked";
  created_at: string;
  invited_by: string;
}

export async function listInvites(status?: string): Promise<AdminInvite[]> {
  const path =
    status && status !== "all"
      ? `/api/admin/invites?status=${encodeURIComponent(status)}`
      : "/api/admin/invites";
  const r = await apiClient.get<{ invites: AdminInvite[] }>(path);
  return r.data.invites;
}

export async function revokeInvite(id: string): Promise<void> {
  await apiClient.post(
    `/api/admin/invites/${encodeURIComponent(id)}/revoke`,
  );
}

// Resend an existing invite — bumps expires_at + re-sends the email with the
// same plain-token. POST /api/admin/invites/{id}/resend → 200 (empty body).
// 404 not_found, 409 invite_not_pending and 403 forbidden surface as toasts.
export async function resendInvite(id: string): Promise<void> {
  await apiClient.post(
    `/api/admin/invites/${encodeURIComponent(id)}/resend`,
  );
}
